import IMask from 'imask';

const serializeForm = (form) => {
  const nodes = form.querySelectorAll('input, select, textarea');
  const obj = {};

  nodes.forEach((node) => {
    if (/\[/.test(node.name)) {
      const names = node.name.replace(/\]/g, '').split('[');

      names.forEach((name, idx) => {
        if (idx === (names.length - 1)) {
          obj[names[idx - 1]][name] = node.value;
        } else if (!(name in obj)) {
          obj[name] = {};
        }
      });
    } else {
      obj[node.name] = node.value;
    }
  });

  return obj;
};

const maskInputs = (form) => {
  const nodes = form.querySelectorAll('.currency-mask, .percent-mask');
  const numberPattern = {
    mask: '$num',
    blocks: {
      num: {
        mask: Number,
        scale: 2,
        thousandsSeparator: ',',
        radix: '.',
        mapToRadix: [','],
      },
    },
  };

  const percentagePattern = {
    mask: [
      {
        mask: '',
      },
      {
        mask: 'num%',
        lazy: false,
        blocks: {
          num: {
            mask: Number,
            scale: 3,
            min: 2,
            max: 100,
            radix: '.',
            mapToRadix: [','],
          },
        },
      },
    ],
  };

  nodes.forEach((node) => {
    if (node.classList.contains('currency-mask')) {
      IMask(node, numberPattern);
    }

    if (node.classList.contains('percent-mask')) {
      IMask(node, percentagePattern);
    }
  });
};

export { serializeForm, maskInputs };
